module.exports = {
        srcSet: __webpack_public_path__ + "destination_host_aldi-60-26fe94e958e82f8f.digested.png"+" 60w",
        images: [{path: __webpack_public_path__ + "destination_host_aldi-60-26fe94e958e82f8f.digested.png",width: 60,height: 72}],
        src: __webpack_public_path__ + "destination_host_aldi-60-26fe94e958e82f8f.digested.png",
        toString: function(){return __webpack_public_path__ + "destination_host_aldi-60-26fe94e958e82f8f.digested.png"},
        
        width: 60,
        height: 72
      }